
import React, { Component } from 'react';

import YearSelect from '../components/timeSelect/YearSelect'
import SemesterSelect from './../components/timeSelect/SemesterSelect'
import MonthSelect from './../components/timeSelect/MonthSelect'
import RangesSelect from './../components/timeSelect/RangesSelect'
import DaySelect from './../components/timeSelect/DaySelect'

import './../components/timeSelect/cliente.css';

//Actualizacion develop
class TimeSelection extends Component {
    render() {
        const drawYears = (yearStart) => {
            var yearList = [];
            var today = new Date();
            for (let i = yearStart; i <= today.getFullYear(); i++) {
                yearList.push(i);
            }
            return yearList;
        }

        return (
            <div >
                <YearSelect years={drawYears(this.props.year)}  />
                <SemesterSelect />
                <MonthSelect />
                <RangesSelect addRange={this.addRange} />
                <DaySelect />
            </div>
        )
    }
}

export default TimeSelection;